import { Subscribe } from 'unstated';

import UserContainer from '~/containers/User';
import Submission from '~/pages/forms/components/Submission';

import Sidebar, {
  SidebarHeader,
  SidebarTitle,
  SidebarTypography,
} from './Sidebar';

class ContactForm extends React.Component {
  render() {
    const { title, body, form_id } = this.props;

    return (
      <Sidebar>
        <SidebarHeader>
          <SidebarTitle>{title}</SidebarTitle>
        </SidebarHeader>

        <SidebarTypography>{body}</SidebarTypography>

        <Subscribe to={[UserContainer]}>
          {(container) => (
            <Submission
              formID={form_id}
              theme="default"
              email={container.state.currentUser.email}
            />
          )}
        </Subscribe>
      </Sidebar>
    );
  }
}

ContactForm.propTypes = {
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  form_id: PropTypes.string.isRequired,
};

export default ContactForm;
